import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as styles from '../MediasUploader.module.less';

/** @type {React.FC<{ icon?: string }>} */
const DraggerContent = ({ icon = 'fb-icon--images-photo-edit' }) => (
  <div className={styles.container}>
    <div className={styles['icon-container']}>
      <span className={`${styles['upload-icon']} ${icon}`} />
    </div>
    <div className={styles.content}>
      <span className={styles.title}>
        <FormattedMessage id="page.fiche.extraInfo.drop_here" defaultMessage="Drag and drop your files here" />
      </span>
      <span className={styles.text}>
        <FormattedMessage id="page.fiche.extraInfo.browse" defaultMessage="Or browse files to upload" />
      </span>
    </div>
  </div>
);

export default DraggerContent;
